import React from "react";

const StepOne = ({
  cardData,
  handleCardClick,
  activeStepOne,
  rosetteTypeOptions,
  rosetteType,
  setRosetteType,
  handleRosetteType,
  selectedPrice,
  setSelectedPrice,
  pricesOptions,
  kitOptions,
  selectedKit,
  setSelectedKit,
}) => {
  const filteredCardData = cardData?.filter(
    (option) => option.size === rosetteType
  );

  return (
    <div className=" text-[#000000] pt-3 text-xs list-none leading-7 relative bg-white ">
      <div>
        <div className="bg-purple-50  border-purple-500 p-4 rounded-r-lg">
          <h1 className="text-lg font-bold text-purple-800 mb-2">
            Fashion your own rosette!
          </h1>
          <p className="text-purple-600 text-sm">
            Visualize and choose your button center, sparkle and text.
          </p>
        </div>
        {/* <div className="m-4 p-2 grid grid-cols-1 md:grid-cols-2 gap-6 border border-gray bg-purple-800">
          <button className="bg-violet-300 m-2 hover:bg-violet-400 transition-colors duration-300 rounded-lg p-2 flex flex-col items-center justify-center min-h-[100px]">
            <img src={rosotteSelect} alt="Rosotte" width="100%" height="auto" />
          </button>
        </div> */}
        {/* <h2 className="text-gray-800 text-lg font-semibold pt-2 bg-white/50 rounded-t-lg px-5">
          DIY Kit Options
        </h2> */}
        {/* <div className="max-w-4xl m-4 p-2 py-4 px-6 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
          <h2 className="text-gray-800 text-lg font-semibold p-2 bg-white/50 rounded-t-lg">
            DIY Kit Options
          </h2>

          <div className="my-2">
            <select
              onChange={(e) => setSelectedPrice(e.target.value)}
              className="w-full p-4 text-left m-2 mx-0 text-md
        bg-white 
        border border-purple-200 
        text-gray-700 
        rounded-lg 
        focus:outline-none 
        focus:ring-2 
        focus:ring-purple-300 
        focus:border-transparent 
        transition-all 
        duration-300 
        hover:shadow-md"
              role="listbox"
              value={selectedPrice || ""}
            >
              {pricesOptions?.map((option, index) => (
                <option
                  key={option.name}
                  value={option.value}
                  className={`
            bg-white 
            text-gray-800 
            hover:bg-purple-50 
            ${index === 0 ? "rounded-t-md" : ""} 
            ${index === pricesOptions.length - 1 ? "rounded-b-md" : ""}`}
                  id={option.name}
                  aria-selected={selectedPrice === option.value}
                >
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="max-w-4xl m-4 p-2 py-4 px-6 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
          <h2 className="text-gray-800 text-lg font-semibold p-2 bg-white/50 rounded-t-lg">
            Add-Ons
          </h2>

          <div className="my-2">
            <select
              onChange={(e) => setSelectedKit(e.target.value)}
              className="w-full p-4 text-left m-2 mx-0 text-md
        bg-white 
        border border-purple-200 
        text-gray-700 
        rounded-lg 
        focus:outline-none 
        focus:ring-2 
        focus:ring-purple-300 
        focus:border-transparent 
        transition-all 
        duration-300 
        hover:shadow-md"
              role="listbox"
              value={selectedKit || ""}
            >
              {kitOptions?.map((option, index) => (
                <option
                  key={option.name}
                  value={option.value}
                  className={`
            bg-white 
            text-gray-800 
            hover:bg-purple-50 
            ${index === 0 ? "rounded-t-md" : ""} 
            ${index === kitOptions.length - 1 ? "rounded-b-md" : ""}`}
                  id={option.name}
                  aria-selected={selectedKit === option.value}
                >
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div> */}
        <div className="max-w-4xl m-4 p-2 py-6 px-6 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
          <h2 className="text-gray-800 text-lg font-semibold p-2 bg-white/50 rounded-t-lg">
            ROSETTE SIZE
          </h2>

          <div className="my-2">
            <select
              onChange={(e) => handleRosetteType(e, e.target.value)}
              className="w-full p-4 text-left m-2 mx-0 text-md
        bg-white 
        border border-purple-200 
        text-gray-700 
        rounded-lg 
        focus:outline-none 
        focus:ring-2 
        focus:ring-purple-300 
        focus:border-transparent 
        transition-all 
        duration-300 
        hover:shadow-md"
              role="listbox"
              value={rosetteType || ""}
            >
              {rosetteTypeOptions?.map((option, index) => (
                <option
                  key={option.name}
                  value={option.value}
                  className={`
            bg-white 
            text-gray-800 
            hover:bg-purple-50 
            ${index === 0 ? "rounded-t-md" : ""} 
            ${index === rosetteTypeOptions.length - 1 ? "rounded-b-md" : ""}`}
                  id={option.name}
                  aria-selected={rosetteType === option.name}
                >
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="max-w-4xl m-4 p-2 py-6 px-6 border border-gray bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg shadow-md">
          <h2 className="text-gray-800 text-lg font-semibold p-2 bg-white/50 rounded-t-lg">
            ROSETTE STYLE
          </h2>

          <div className="my-2">
            <select
              onChange={(e) => handleCardClick(e, e.target.value)}
              className="w-full p-4  text-left m-2 mx-0 
              text-md
        bg-white 
        border border-blue-200 
        text-gray-700 
        rounded-lg 
        focus:outline-none 
        focus:ring-2 
        focus:ring-blue-300 
        focus:border-transparent 
        transition-all 
        duration-300 
        hover:shadow-md"
              role="listbox"
              value={activeStepOne || ""}
            >
              {filteredCardData?.map((option, index) => (
                <option
                  key={option.label}
                  value={option.label}
                  className={`
            bg-white 
            text-gray-800 
            hover:bg-blue-50 
            ${index === 0 ? "rounded-t-md" : ""} 
            ${index === cardData.length - 1 ? "rounded-b-md" : ""}`}
                  id={option.label}
                  aria-selected={activeStepOne === option.label}
                >
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepOne;
